const ANNUAL_RETURN_RATE = 14;

export default ANNUAL_RETURN_RATE;
